import { useMediaQuery } from 'react-responsive'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import styles from './toast.module.scss'
import { Button } from '@/components/styleguide/Button'
import { ButtonHierarchy } from '@/components/styleguide/Button/Button'
import { Size, Theme } from '@/types/system'

export const Toast = () => {
  const isMobile = useMediaQuery({ maxWidth: 992 })
  return (
    <ToastContainer
      closeOnClick
      progressClassName={styles.progress}
      bodyClassName={styles.body}
      toastClassName={styles.toast}
      className={styles.container}
      closeButton={() => (
        <Button
          label="Close"
          size={Size.Small}
          hierarchy={ButtonHierarchy.BezeledGray}
          theme={Theme.dark}
        />
      )}
      position={isMobile ? 'bottom-center' : 'bottom-left'}
      pauseOnHover={false}
    />
  )
}
